module.exports = __webpack_public_path__ + "img/volatility.0f4fd93d.png";